module.exports = __webpack_public_path__ + "fonts/lato-all-300-normal.6e49c6c.woff";